<script setup lang="ts">
import UiIcon from '~/components/ui/UiIcon/UiIcon.vue';
</script>

<template>
    <NuxtLink
        to="/"
        aria-label="На главную"
        class="logo"
    >
        <UiIcon name="svg/logo" class="logo__image" />
    </NuxtLink>
</template>

<style scoped lang="scss">
</style>
